export enum WordGraphType {
	FILLER = 'Filler',
	HEDGING = 'Hedging'
}
